<template>
    <div :class="[hideHeader && 'hideHeader', !center && 'text-start']">
        <el-dialog
                :center="center"
                :title="this.title"
                :close-on-click-modal="overlayClose"
                :show-close="showClose"
                :visible.sync="this.dialog"
                :fullscreen="fullscreen"
                :width="width?width:'80%'"
                :custom-class="customClass"
                :before-close="handleParentClose">
            <slot/>
            <div slot="footer" class="dialog-footer" v-if="!hideFooter">
                <!--    <el-button @click="dialogVisible = false">Cancel</el-button>-->
                <K2Row justify_content="flex-end">
                    <K2Button @onclick="handleParentConfirm()">
                        <K2Text color="white">{{confirmText ? confirmText : "Post"}}</K2Text>
                    </K2Button>
                </K2Row>
            </div>
        </el-dialog>
    </div>

</template>

<script>
  import K2Button from "../k2Button/k2Button";
  import K2Text from "../k2Text/k2Text";
  import K2Row from "../k2Row/k2Row";
  import "./k2Modal.scss";

  export default {
    name: "K2Modal",
    components: { K2Row, K2Text, K2Button },
	  props: {
		  width: {
			  type: String,
		  },
		  dialog: {
			  type: Boolean,
		  },
		  handleClose: {
			  type: Function,
		  },
		  onConfirm: {
			  type: Function,
		  },
		  title: {
			  type: String,
		  },
		  overlayClose: {
			  type: Boolean,
			  default: true
		  },
		  showClose: {
			  type: Boolean,
			  default: true
		  },
		  hideHeader: {
			  type: Boolean,
		  },
		  fullscreen: {
			  type: Boolean,
		  },
		  confirmText: {
			  type: String,
			  default: 'Confirm'
		  },
		  hideFooter: {
			  type: Boolean,
		  },
		  center:{
				type: Boolean,
			  default: true
		  },
		  bodyClass:{
			  type: String,
		  }
	  },
    methods: {
      handleParentClose() {
        this.$emit("handleClose");
      },
      handleParentConfirm() {
        this.$emit("onConfirm");
      }
    },
	  computed: {
		  customClass() {
			  return ['k2Modal', this.hideFooter && 'pb-4', this.bodyClass].filter(Boolean).join(' ');
		  },
	  }
  };
</script>